<template>
  <div class="page">
    <div
      class="page-header"
      :style="[
        { backgroundColor: headerBackgroundColor, boxShadow: headerBoxShadow }
      ]"
    >
      <div class="page-header-container">
        <div class="page-header-left">
          <img class="page-header-logo" src="@/assets/images/logo.png" />
          <span class="page-header-title">服务中心</span>
        </div>
        <div class="page-header-nav">
          <el-link
            class="mr-12"
            :underline="false"
            href="https://jiker.feishu.cn/docs/doccnfwavjkQSSxrHTb4432imOh"
            target="_blank"
            ><i class="el-icon-question"></i> 帮助中心</el-link
          >
        </div>
        <div class="page-header-right" v-if="!userName">
          <div class="user-login" @click="handlelogin">登录/注册</div>
        </div>
        <el-dropdown
          v-if="userName"
          style="height: 100%"
          @command="handleCommand"
        >
          <div class="page-header-right">
            <img class="user-avatar" :src="userAvatar" />
            <span class="user-name">{{ userName }}</span>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <div class="user-info">
              <img class="user-info-avatar" :src="userAvatar" />
              <p class="user-info-name">{{ userName }}</p>
              <p class="user-info-line"></p>
            </div>
            <el-dropdown-item style="text-align: center" command="handleLogout">
              退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="page-body">
      <div class="page-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      headerBackgroundColor: "#fff",
      headerBoxShadow: "0 1px 2px 0 rgba(0, 0, 0, .06)",
      navBackgroundColor: "",
      navTextColor: "",
      navActiveTextColor: ""
    };
  },
  computed: {
    ...mapState(["userAvatar", "userName", "authPermissions"])
  },
  methods: {
    handleCommand(command) {
      this[command]();
    },
    handleLogout() {
      this.$store.dispatch("logout");
    },
    handlelogin() {
      this.$store.dispatch("login");
    }
  }
};
</script>
<style lang="less" scoped>
.nav-svg {
  margin-right: 5px;
  width: 24px;
  height: 18px;
  vertical-align: middle;
  color: #909399;
}
.el-menu-item.is-active .nav-svg {
  color: #409eff;
}
.nav-svg-record {
  padding: 1px;
}

.user-info {
  width: 150px;
  .user-info-avatar {
    display: block;
    margin: 24px auto 12px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  .user-info-name {
    margin-bottom: 24px;
    font-size: 14px;
    color: #606266;
    text-align: center;
  }
  .user-info-line {
    margin-bottom: 10px;
    height: 1px;
    width: 100%;
    background: rgba(0, 0, 0, 0.05);
  }
}

.page {
  min-width: 1280px;
  .page-header {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 1501;
    height: 72px;
    .page-header-container {
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      width: 1280px;
      height: 100%;
      line-height: 40px;
      .page-header-left {
        display: flex;
        margin-top: 16px;
        .page-header-logo {
          height: 40px;
        }
        .page-header-title {
          margin-left: 12px;
          font-size: 24px;
          font-weight: 500;
          white-space: nowrap;
        }
      }
      .page-header-nav {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      .page-header-right {
        display: flex;
        align-items: center;
        padding: 0 20px;
        height: 100%;
        transition: all 0.2s ease;
        cursor: pointer;
        &:hover {
          background: #ecf5ff;
        }
        .user-avatar {
          margin-right: 12px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
        }
        .user-name {
          margin-right: 12px;
          font-size: 14px;
        }
        .user-login {
          width: 100%;
          height: 100%;
          line-height: 72px;
          text-align: center;
          color: #606266;
          font-size: 14px;
        }
      }
    }
  }
  .page-body {
    display: flex;
    // margin: 20px auto;
    width: 100%;
    // width: 1280px;
    .page-content {
      flex: none;
      // padding: 30px;
      width: 100%;
      // width: 1280px;
      height: 100%;
      min-height: 600px;
      background: #fff;
    }
  }
}
</style>
